import script from "./ProductivityChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductivityChart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__